'use strict';

import { Component, ViewChild, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

declare const CodeMirror: any;

export const UI_CODE_CONTROL_VALUE_ACCESSOR: any = {
  provide    : NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CodeEditorComponent),
  multi      : true
};

@Component({
  selector       : 'code-editor',
  template: `<textarea #editorEl ([ngModel])="pattern"></textarea>
`,
  styles: [``],
  providers  : [UI_CODE_CONTROL_VALUE_ACCESSOR]
})
export class CodeEditorComponent implements ControlValueAccessor, OnInit {

  @ViewChild('editorEl') editorEl;
  @Input() readOnly = false;
  @Input() height: number;
  @Input() lineNumbers = true;
  @Input() dialect: string;
  @Input() lint: boolean;
  @Input() autofocus: boolean;
  @Input() placeholder: string;
  private _pattern = '';
  public editor: any;

  private onTouchedCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void = () => {};

  constructor () {}

  ngOnInit() {
    this.editor = CodeMirror.fromTextArea(
      this.editorEl.nativeElement,
      {
        mode : (this.dialect === 'JSON') ? 'application/x-cypher-query' : 'application/json',
        indentWithTabs : false,
        smartIndent : false,
        height: this.height,
        lineNumbers : this.lineNumbers,
        autofocus : ( this.autofocus !== false ),
        theme : 'neo',
        lineWrapping : true,
        placeholder : (this.placeholder) ? this.placeholder : '',
        readOnly : ( this.readOnly ) ? 'nocursor' : false,
        lint : this.lint,
        gutter : (this.lint) ? ["CodeMirror-lint-markers"] : undefined
      }
    );

    if ( this.height ) {
      this.editor.setSize('100%', this.height);
    }

    this.editor.on('change', () => {
      this.setValue(this.editor.getValue());
    });
  }

  /**
   * update values for parent and child NgModel
   */
  set pattern (value: any) {
    this._pattern = value;
    this.onChangeCallback(this._pattern);
  }

  get pattern () {
    return this._pattern;
  }

  /**
   * set each parent and child NgModel values when a result is selected
   */
  setValue (value: string) {
    this.pattern = value;
  }

  registerOnChange (fn) {
    this.onChangeCallback = fn;
  }

  registerOnTouched (fn) {
    this.onTouchedCallback = fn;
  }

  writeValue (value: any) {
    if (this.editor && value !== null) {
      this.editor.getDoc().setValue(value);
      this.pattern = value;
    }
  }
}
